/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import TextField from '@mui/material/TextField';
import Text from '@mui/material/Typography';
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';
import Checkbox from '@mui/material/Checkbox';

import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

const INDUSTRIES = [
  i18n.t('Juridik'),
  i18n.t('Forskning'),
  i18n.t('Media'),
  i18n.t('Rekrytering'),
  i18n.t('Journalistik'),
  i18n.t('IT'),
  i18n.t('Annat'),
];

const RESEARCH_AREAS = [
  i18n.t('Humaniora och konst'),
  i18n.t('Medicin och hälsovetenskap'),
  i18n.t('Samhällsvetenskap, beteendevetenskap och ekonomi'),
  i18n.t('Teknik och naturvetenskap'),
  i18n.t('Annat'),
];

export default function Step3Company({
  role,
  fullName,
  telephoneNumber,
  employees,
  name,
  industry,
  isResearcher = false,
  onUpdate,
  newsletter,
}) {
  const { t } = useTranslation();

  return (
    <div
      css={css`
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        width: 100%;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          gap: 1rem;
          flex-grow: 1;
        `}
      >
        <Text variant="subtitle1" fontWeight="600">
          {t('Företagsinformation')}
        </Text>
        <TextField
          label={t('Företagsnamn')}
          placeholder={t('Företag/organisations namn')}
          size="small"
          autoComplete="off"
          value={name}
          onChange={(e) => onUpdate({ name: e.target.value })}
        />
        <FormControl sx={{ width: '100%' }} size="small">
          <InputLabel>{t('Antal anställda')}</InputLabel>
          <Select
            label={t('Antal anställda')}
            value={employees || ''}
            onChange={(e) => onUpdate({ employees: e.target.value })}
          >
            <MenuItem value="1-10">1-10</MenuItem>
            <MenuItem value="11-50">11-50</MenuItem>
            <MenuItem value="51-100">51-100</MenuItem>
            <MenuItem value="101-500">101-500</MenuItem>
            <MenuItem value="501-1000">501-1000</MenuItem>
            <MenuItem value="1000+">1000+</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ width: '100%' }} size="small">
          <InputLabel>{isResearcher ? t('Område') : t('Bransch')}</InputLabel>
          <Select
            value={industry || ''}
            label={isResearcher ? t('Område') : t('Bransch')}
            onChange={(e) => onUpdate({ industry: e.target.value })}
          >
            {(isResearcher ? RESEARCH_AREAS : INDUSTRIES).map((industry) => (
              <MenuItem key={industry} value={industry}>
                {industry}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label={t('Din roll på företaget')}
          placeholder={t('CEO, Marknadschef, etc.')}
          size="small"
          autoComplete="off"
          value={role}
          onChange={(e) => onUpdate({ role: e.target.value })}
        />
      </div>
      <div
        css={css`
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          gap: 1rem;
          max-width: 410px;
        `}
      >
        <Text variant="subtitle1" fontWeight="600">
          {t('Dina kontaktuppgifter')}
        </Text>
        <TextField
          label={t('Ditt fullständiga namn')}
          placeholder={t('För- och efternamn')}
          size="small"
          autoComplete="off"
          value={fullName}
          onChange={(e) => onUpdate({ fullName: e.target.value })}
        />
        <TextField
          label={t('Telefonnummer')}
          placeholder="+46"
          size="small"
          autoComplete="off"
          value={telephoneNumber}
          onChange={(e) => onUpdate({ telephoneNumber: e.target.value })}
        />
        <FormControlLabel
          sx={{ marginTop: '1rem' }}
          control={<Checkbox />}
          label={t(
            'Jag vill få praktiska tips, produktuppdateringar och information om Klang via e-post'
          )}
          checked={newsletter}
          onChange={(e) => onUpdate({ newsletter: e.target.checked })}
        />
      </div>
    </div>
  );
}
